import { render } from "./modelfive.vue?vue&type=template&id=9938aeb4"
import script from "./modelfive.vue?vue&type=script&lang=js"
export * from "./modelfive.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__